// utils/navigation.ts
export const scrollToSection = (target: string) => {
  document
    .getElementById(target)
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};